(function($) {
  $(document).ready(function(){ 
    $(".collection .owl-carousel").each(function() {
      $(this)
        .owlCarousel({
          loop: false,
          nav: true,
          dots: false,
          autoplay: false,
          stagePadding: 0,
          smartSpeed: 500,
          navContainer: $(this).parent(),
          navText: [
            "<i class='icon-arrow'></i>",
            "<i class='icon-arrow'></i>"
          ],

          responsive: {
            0: {
              items: 1,
              slideBy: 1,
              singleItem: true,
              margin: 0
            },
            768: {
              items: 3,
              slideBy: 3,
              singleItem: false,
              margin: 10
            }
          }
        })
        .trigger("refresh.owl.carousel");
    });
  });
})(jQuery);